export const AssignmentTaskType = {
  MultipleChoice: 'MultipleChoice',
  FillInTheBlanks: 'FillInTheBlanks',
  TrueOrFalse: 'TrueOrFalse',
  MultipleChoicePicture: 'MultipleChoicePicture',
  MultiSelectText: 'MultiSelectText',
};

export const AssignmentTaskTitle = {
  [AssignmentTaskType.MultipleChoice]: 'Multiple Choice',
  [AssignmentTaskType.FillInTheBlanks]: 'Fill in the Blanks',
  [AssignmentTaskType.TrueOrFalse]: 'True or False',
  [AssignmentTaskType.MultipleChoicePicture]: 'Multiple Choice Pictures',
  [AssignmentTaskType.MultiSelectText]: 'Multi-select text',
};
